<template>
  <div class="row supplierPerformance">
    <div v-if="loading" class="col-12 col-sm-3" >
      <span class="loading text-muted">Loading...</span>
    </div>
    <div v-if="!loading" class="col-12 col-sm-3" >
      <!-- <div class="col-12">
        <div class="row">
          <div class="col-sm-5"><small>Internal Only</small></div>
          <div class="col-sm-2"><input type="checkbox" disabled="true" /></div>
          <div class="col-sm-5 text-muted"><small>Industry Avg</small></div>
        </div>
      </div> -->
      <div class="col-12" >
        <p><small class="text-muted">Weighted Rating</small><br><span style="font-size: 22px">{{ weightedRating }}</span></p>
      </div>
      <div class="col-12" >
        <p><small class="text-muted">Average Rating</small><br><span style="font-size: 22px">{{ averageRating }}</span></p>
      </div>
    </div>
    <div v-if="!loading" class="col-12 col-sm-9" >
      <div style="position:fixed; left:260px; top:6px;">
        <ul class="nav">
          <li class="nav-item">
            <a v-bind:class="['nav-link', (isYearlySpend? 'active': '')]" v-on:click="setIsYearlySpend(true)"><span>Yearly Spend</span></a>
          </li>
          <li class="nav-item">
            <a v-bind:class="['nav-link', (!isYearlySpend? 'active': '')]" v-on:click="setIsYearlySpend(false)"><span>Performance</span></a>
          </li>
        </ul>
      </div>
      <div v-show="isYearlySpend" >
        <bar-chart
          style="height:200px;"
          :chartdata="yearlySpendChartdata"
          :options="yearlySpendOptions"
          />
      </div>
      <div v-show="!isYearlySpend">
        <bar-chart
          style="height:200px;"
          :chartdata="performanceChartdata"
          :options="performanceOptions"
          />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import BarChart from '../../components/chart/BarChart.vue'

import apiService from '../../services/api.service'

import { checkResponseErrors } from '../../utils/http'
import moment from 'moment'

export default {
  name: 'SupplierPerformanceWidget',
  data: () => ({
    loading: true,
    isYearlySpend: true,
    yearlySpendChartdata: null,
    yearlySpendOptions: null,
    performanceChartdata: null,
    performanceOptions: null,
    weightedRating: "-",
    averageRating: "-"
  }),
  components: {
    BarChart
  },
  async mounted () {
    this.loading = true;

    try {
      const resp = await apiService.get('/dashboard/supplierPerformance');
      if(await checkResponseErrors(resp)) return;

      this.yearlySpendOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false,
              drawTicks: true,
              color: 'white',
              offsetGridLines: false,
            },
            ticks: {
              fontColor: '#969696',
            }
          }],
          yAxes: [{
            gridLines: {
              lineWidth: [1, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
              drawTicks: false,
            },
            ticks: {
              fontColor: '#969696',
              padding: 15,
              min: 0,
              max: 100,
              maxTicksLimit: 25,
              stepSize: 5,
              callback: (value, index, values) => {
                return getPerformanceTick(value)
              },
            }
          }]
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          callbacks: {
            title: (tooltipItem, data) => {
              var chartData = data.datasets[tooltipItem[0].datasetIndex].chartData[tooltipItem[0].index - 1] || '';
              return chartData.SUPPLIER_NAME;
            },
            label: (tooltipItem, data) => {
              var label = "Rating: "
              var chartData = data.datasets[tooltipItem.datasetIndex].chartData[tooltipItem.index - 1] || '';
              label += chartData.RATING_LABEL
              label += " ("
              label += formatNumber(chartData.RATING)
              label += ")"
              return label;
            },
            afterLabel: (tooltipItem, data) => {
              var label = "Yearly Spend: "
              var chartData = data.datasets[tooltipItem.datasetIndex].chartData[tooltipItem.index - 1] || '';
              label += formatPrice(chartData.TOTAL_COST)
              return label;
            },
          }
        },
      }
      this.performanceOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false,
              drawTicks: true,
              color: 'white',
              offsetGridLines: false,
            },
            ticks: {
              fontColor: '#969696',
            }
          }],
          yAxes: [{
            gridLines: {
              drawTicks: false,
            },
            ticks: {
              fontColor: '#969696',
              min: 0,
              padding: 15,
              maxTicksLimit: 5,
              beginsAtZero: true,
              callback: (value, index, values) => {
                return formatPrice(value)
              },
            },
          }]
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          callbacks: {
            title: (tooltipItem, data) => {
              var chartData = data.datasets[tooltipItem[0].datasetIndex].chartData[tooltipItem[0].index - 1] || '';
              return chartData.SUPPLIER_NAME;
            },
            label: (tooltipItem, data) => {
              var label = "Rating: "
              var chartData = data.datasets[tooltipItem.datasetIndex].chartData[tooltipItem.index - 1] || '';
              label += chartData.RATING_LABEL
              label += " ("
              label += formatNumber(chartData.RATING)
              label += ")"
              return label;
            },
            afterLabel: (tooltipItem, data) => {
              var label = "Yearly Spend: "
              var chartData = data.datasets[tooltipItem.datasetIndex].chartData[tooltipItem.index - 1] || '';
              label += formatPrice(chartData.TOTAL_COST)
              return label;
            },
          }
        },
      }

      if(resp.data.data.chart.length <= 1){
        this.loading = false
        return
      }

      // Side Data
      this.weightedRating = resp.data.data.weightedAvg_label + " (" + formatNumber(resp.data.data.weightedAvg) + ")"
      this.averageRating = resp.data.data.avg_label + " (" + formatNumber(resp.data.data.avg) + ")"

      // Yearly Spend Chart
      this.yearlySpendChartdata = initYearlySpendWidgetData(resp.data);

      // Performance Chart
      this.performanceChartdata = initPerformanceWidgetData(resp.data);
      this.loading = false;
    } catch (error) {
      Vue.toasted.error(error, { duration: 3500 });
      return;
    }
  }, // end mounted
  methods: {
    setIsYearlySpend: function(value) {
      if(value != this.isYearlySpend){
        this.isYearlySpend = value
      }
    }
  }
}

const initYearlySpendWidgetData = (data) => {
  data.data.chart = data.data.chart.sort((dataA, dataB) => dataA.TOTAL_COST - dataB.TOTAL_COST)

  var widgData = {};
  widgData.labels = Array(data.data.chart.length + 2).fill('')
  widgData.labels[0] = 'Low'
  widgData.labels[data.data.chart.length + 1] = 'High'
  widgData.datasets = []

  var widgDataset = {}
  widgDataset.chartData = []
  widgDataset.data = []
  widgDataset.backgroundColor = []
  widgDataset.barPercentage = 1.0
  widgDataset.categoryPercentage = 1.0

  // Build Dataset Points
  widgDataset.data.push(0)
  widgDataset.backgroundColor.push(getDataBackgroundColor(''))
  data.data.chart.forEach((element) => {
    widgDataset.chartData.push(element)
    widgDataset.data.push(element.RATING)
    widgDataset.backgroundColor.push(getDataBackgroundColor(element.RATING_LABEL))
  })
  widgDataset.data.push(0)
  widgDataset.backgroundColor.push(getDataBackgroundColor(''))

  widgData.datasets.push(widgDataset)
  return widgData
}

const initPerformanceWidgetData = (data) => {
  data.data.chart.sort((datasetA, datasetB) => datasetA.RATING - datasetB.RATING)

  var widgData = {};
  widgData.labels = Array(data.data.chart.length + 2).fill('')
  widgData.labels[0] = 'Low'
  widgData.labels[data.data.chart.length + 1] = 'High'
  widgData.datasets = []

  var widgDataset = {}
  widgDataset.chartData = []
  widgDataset.data = []
  widgDataset.backgroundColor = []
  widgDataset.barPercentage = 1.0
  widgDataset.categoryPercentage = 1.0

  // Build Dataset Points
  widgDataset.data.push(0)
  widgDataset.backgroundColor.push(getDataBackgroundColor(''))
  data.data.chart.forEach((element) => {
    widgDataset.chartData.push(element)
    widgDataset.data.push(element.TOTAL_COST)
    widgDataset.backgroundColor.push(getDataBackgroundColor(element.RATING_LABEL))
  })
  widgDataset.data.push(0)
  widgDataset.backgroundColor.push(getDataBackgroundColor(''))

  widgData.datasets.push(widgDataset)
  return widgData
}

const getDataBackgroundColor = (rating) => {
  switch(rating){
    case "OK":
      return "#ffb103"
    case "Good":
      return "#64b57b"
    case "Excellent":
      return "#5bd67d"
    case "Poor":
    default:
      return "#dd6493"
  }
}

const formatNumber = (value) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  return formatter.format(value)
}

const formatPrice = (value) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  return formatter.format(value)
}

const getPerformanceTick = (value) => {
  if(value == 20){
    return "Poor"
  }
  if(value == 45){
    return "OK"
  }
  if(value == 65){
    return "Good"
  }
  if(value == 85){
    return "Excellent"
  }
  return ""
}

</script>



// WEBPACK FOOTER //
// SupplierPerformanceWidget.vue?d621134e